$(document).ready(function () {
  $.urlParam = function (e) {
    var t = new RegExp("[?&]" + e + "=([^&#]*)").exec(window.location.href);
    return null == t ? null : decodeURI(t[1]) || 0;
  };
  var e = {
    ".one-omega-bottle": {
      id: ".one-omega-bottle",
      quantity: "One Bottle",
      frequency: 30,
      freq: 1,
      vid: "38054112526513",
    },
    ".two-omega-bottle": {
      id: ".two-omega-bottle",
      quantity: "Two Bottles",
      frequency: 60,
      freq: 2,
      vid: "38054112559281",
    },
    ".four-omega-bottle": {
      id: ".four-omega-bottle",
      quantity: "Four Bottles",
      frequency: 120,
      freq: 4,
      vid: "38054112592049",
    },
  };
  for (var t in e)
    $(t).attr("data-id", t),
      $(t).click(function () {
        console.log("click");
        var t = $(this).attr("data-id"),
          o = e[t];
        $("#subscription .quant").html("Quantity: " + o.quantity),
          $("#subscription .freq").html(
            "Frequency: Every " + o.frequency + " Days"
          ),
          $("#subscription a.no").attr("data-id", o.id),
          $("#subscription a.yes").attr("data-id", o.id),
          $("#subscription").modal({
            escapeClose: !1,
            clickClose: !1,
            showClose: !1,
          });
      });
  $("#subscription a.yes").click(function () {
    var t = $(this).attr("data-id"),
      o = e[t];
    console.log(o),
      $('#productSelect option[value="' + o.vid + '"]').prop("selected", !0);
    var r = new Event("change");
    $("#productSelect").get(0).dispatchEvent(r),
      $("#productSelect").change(),
      setTimeout(function () {
        $(".bold-ro__recurring-div .bold-ro__recurring-lbl").click(),
          setTimeout(function () {
            $(".bold-ro__frequency-num").val(o.freq),
              $(".bold-ro__frequency-num option[value='" + o.freq + "']").attr(
                "selected",
                "selected"
              ),
              $(".bold-ro__frequency-num option[value='" + o.freq + "']")
                .prop("selected", !0)
                .change(),
              setTimeout(function () {
                console.log($(".bold-ro__recurring-div")),
                  console.log($(".bold-ro__frequency-num").val()),
                  $("#AddToCart").click();
              }, 50);
          }, 50);
      }, 50);
  }),
    // $("#subscription a.no").click(function () {
    //   e.preventDefault();
    //   $("#subscription").modal("close");
    //   $("#subscription").hide();

    //   // Trigger Add to Cart
    //   $("#AddToCart").click();
    // }),

$("#subscription a.no").click(function (event) {
    event.preventDefault();
    $("#subscription").modal("close");
    $("#subscription").hide();

    var t = $(this).attr("data-id"),
        o = e[t];

    console.log("NO subscription - adding to cart:", o);

    // Select the correct product variant
    $('#productSelect option[value="' + o.vid + '"]').prop("selected", true);

    // Dispatch change event
    var r = new Event("change");
    $("#productSelect").get(0).dispatchEvent(r);
    $("#productSelect").change();

    // Force one-time purchase by clearing any subscription data
    setTimeout(function () {
        // Clear subscription selections
        $('input[name="selling_plan"]').val('');
        $('select[name="selling_plan"]').val('').trigger('change');
        
        // If there's a one-time button, click it
        if ($(".bold-ro__one-time-div").length) {
            $(".bold-ro__one-time-div").click();
        }
        
        $("#AddToCart").click();
    }, 50);
});

    $(".header-menu li.has-child-menu").each(function () {
      $(this)
        .find("a")
        .first()
        .append(
          '<span class="open-submenu"><i class="fas fa-angle-down"></i></span>'
        );
    }),
    $(".bundle-save .products").slick({
      slidesToShow: 1,
      infinite: !0,
      arrows: !1,
      dots: !0,
      initialSlide: 1,
      mobileFirst: !0,
      responsive: [
        { breakpoint: 1e3, settings: { slidesToShow: 3, dots: !1 } },
      ],
    }),
    $(".product .select .active").click(function () {
      $(".product .select ul").toggle(0);
    }),
    $(".bold-ro__frequency-type.bold-ro__order-interval").val(3),
    $(
      ".bold-ro__frequency-type.bold-ro__order-interval option[value='3']"
    ).attr("selected", "selected"),
    $(".bold-ro__frequency-type.bold-ro__order-interval option[value='3']")
      .prop("selected", !0)
      .change(),
    $(".product .select li").click(function () {
      var e = $(".product .active"),
        t = e.text(),
        o = e.data("id");
      e.html($(this).text()),
        e.data("id", $(this).data("id")),
        $('#productSelect option[value="' + $(this).data("id") + '"]').prop(
          "selected",
          !0
        );
      var r = new Event("change");
      $("#productSelect").get(0).dispatchEvent(r),
        $("#productSelect").change(),
        $(this).html(t),
        $(this).data("id", o),
        $(".product ul").hide(0);
    }),
    $(".bold-ro__recurring-div").addClass("red-btn"),
    $(document).on("click", ".bold-ro__one-time-div", function () {
      $(".bold-ro__one-time-div").addClass("red-btn"),
        $(".bold-ro__one-time-div").removeClass("transparent-btn"),
        $(".bold-ro__recurring-div").addClass("transparent-btn"),
        $(".bold-ro__recurring-div").removeClass("red-btn");
    }),
    $(document).on("click", ".bold-ro__recurring-div", function () {
      $(".bold-ro__one-time-div").removeClass("red-btn"),
        $(".bold-ro__one-time-div").addClass("transparent-btn"),
        $(".bold-ro__recurring-div").removeClass("transparent-btn"),
        $(".bold-ro__recurring-div").addClass("red-btn");
      var e = $(".product .active").text();
      console.log(e),
        console.log(e.includes("Single")),
        e.includes("Single")
          ? ($(".bold-ro__frequency-num").val(1),
            $(".bold-ro__frequency-num option[value='1']").attr(
              "selected",
              "selected"
            ),
            $(".bold-ro__frequency-num option[value='1']")
              .prop("selected", !0)
              .change())
          : e.includes("2")
          ? ($(".bold-ro__frequency-num").val(2),
            $(".bold-ro__frequency-num option[value='2']").attr(
              "selected",
              "selected"
            ),
            $(".bold-ro__frequency-num option[value='2']")
              .prop("selected", !0)
              .change())
          : e.includes("4") &&
            ($(".bold-ro__frequency-num").val(4),
            $(".bold-ro__frequency-num option[value='4']").attr(
              "selected",
              "selected"
            ),
            $(".bold-ro__frequency-num option[value='4']")
              .prop("selected", !0)
              .change()),
        $(".bold-ro__frequency-type.bold-ro__order-interval").val(3),
        $(
          ".bold-ro__frequency-type.bold-ro__order-interval option[value='3']"
        ).attr("selected", "selected"),
        $(".bold-ro__frequency-type.bold-ro__order-interval option[value='3']")
          .prop("selected", !0)
          .change();
    }),
    $(".dropdown-item").click(function () {
      $(this).toggleClass("opened"),
        $(this).find(".text").slideToggle(300),
        $(this).siblings(".dropdown-item").removeClass("opened"),
        $(this).siblings(".dropdown-item").find(".text").slideUp(300);
    });
  var o =
    "$" +
    $("#AddToCartForm .select .active")
      .text()
      .split("$")[1]
      .replace("USD", " ") +
    " " +
    currentOneTimeTxt;
  $(".bold-ro__one-time-purchase").text(o),
    $(".product .select li").click(function () {
      var e = $(".product .active"),
        t = e.text(),
        o = e.data("id");
      e.html($(this).text());
      var r =
        "$" +
        $(this).text().split("$")[1].replace("USD", " ") +
        " One-time purchase";
      $(".bold-ro__one-time-purchase").text(r),
        e.data("id", $(this).data("id")),
        $('#productSelect option[value="' + $(this).data("id") + '"]').prop(
          "selected",
          !0
        );
      var n = new Event("change");
      $("#productSelect").get(0).dispatchEvent(n),
        $("#productSelect").change(),
        $(this).html(t),
        $(this).data("id", o),
        $(".product ul").hide(0);
    });
});
